import { Component, OnInit } from '@angular/core';
import { UserLogicService } from '../../logic/user.service'
import { RegisteredUserModel } from '../../interfaces/interfaces';
import { Observable, combineLatest, forkJoin, of, BehaviorSubject } from 'rxjs';
import {
  map,
  switchMap,
  mergeAll,
  first,
  flatMap,
  filter,
  exhaustMap,
  take,
} from 'rxjs/operators';
import { PassDataService } from '../../services/pass-data.service';

@Component({
  selector: 'users-pg',
  templateUrl: './users.component.html',
})
export class UsersPage implements OnInit {

  page: number = 1;

  usersList$: Observable<RegisteredUserModel[]> = new Observable<
  RegisteredUserModel[]
  >();

  constructor(
    private userLogicService: UserLogicService,
    private passDataService: PassDataService
  ) { }

  ngOnInit(): void {
    this.usersList$ = this.userLogicService.getAllRegisteredUsersLogic()
    .pipe(
      switchMap((s) => {
        this.passDataService.setAllUsers(s.data.users);
        return [s.data.users]
      })
    )
  }

}
